<template>
  <div>
    <!--    <div class="u-flex u-row-between ps">-->
    <!--      <p>尊敬的用户您好，依据国家相关法律的规定，为了保证您的账户安全，请您尽快完成实名认证去认证</p>-->
    <!--      <el-button type="danger" size="small">去认证</el-button>-->
    <!--    </div>-->
    <div class="approve" v-if="active === 1">
      <ul class="u-flex u-row-between">
        <li class="item">
          <img src="@/assets/images/geren.png" alt="">
          <h4 class="mt20 name">个人认证</h4>
          <div class="solan">台授权支付宝安全认证，不会泄露您的认证信息</div>
          <el-button class="once-approve" type="primary" @click="onOnceApprove(0)" :disabled="personAuthForm.passed==1">
            立即认证
          </el-button>
        </li>

        <li class="item">
          <img src="@/assets/images/qiye.png" alt="">
          <h4 class="mt20 name">企业认证</h4>
          <div class="solan">企业认证需要提交营业执照相关资料 非企业用户请勿选择此通道</div>
          <el-button class="once-approve"
                     type="primary" @click="onOnceApprove(1)"
                     :disabled="enterpriseAuthForm.passed==1 || enterpriseAuthForm.status ==0">
            立即认证
          </el-button>
        </li>
      </ul>
    </div>
    <div class="approve" v-if="active === 2">
      <div class="u-flex u-row-between" v-if="authType==1">
        <div>
          <h3 class="title">企业认证</h3>
          <p class="desc">
            卓泓HTTP采用支付宝实名认证服务，仅能获取支付宝返回的实名认证结果信息，您的实名信息仍将保留在支付宝，受支付宝数据安全保护</p>
          <el-form ref="form" class="form" label-position="top" label-width="80px" :model="enterpriseAuthForm">
            <el-form-item label="真实姓名" prop="cert_name"
                          :rules="{required:true,message:'请输入姓名',trigger: 'blur'}">
              <el-input v-model="enterpriseAuthForm.cert_name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="cert_no"
                          :rules="{required:true,message:'请输入身份证号',trigger: 'blur'}">
              <el-input v-model="enterpriseAuthForm.cert_no" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="营业执照" v-if="authType == 1">
              <upload @getImg="(data)=>upload(data)" :img-url="enterpriseAuthForm.enterprise_image"
                      key="enterprise_image"
                      :isDuotu="false"/>
            </el-form-item>
            <el-button class="pay" type="primary" size="mini" @click="onAliApprove"
                       :disabled="enterpriseAuthForm.status==1">
              支付宝认证
            </el-button>
          </el-form>
        </div>
        <div class="ml50">
          <img src="../assets/images/xq1.png" alt="">
        </div>
      </div>
    </div>
    <div class="approve" v-if="active === 2">
      <div class="u-flex u-row-between" v-if="authType==0">
        <div>
          <h3 class="title">个人认证</h3>
          <p class="desc">
            卓泓HTTP采用支付宝实名认证服务，仅能获取支付宝返回的实名认证结果信息，您的实名信息仍将保留在支付宝，受支付宝数据安全保护</p>
          <el-form ref="personAuthForm" class="form" label-position="top" label-width="80px" :model="personAuthForm">
            <el-form-item label="真实姓名" prop="cert_name"
                          :rules="{required:true,message:'请输入姓名',trigger: 'blur'}">
              <el-input v-model="personAuthForm.cert_name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="cert_no"
                          :rules="{required:true,message:'请输入身份证号',trigger: 'blur'}">
              <el-input v-model="personAuthForm.cert_no" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-button class="pay" type="primary" size="mini" @click="submitUserAuth"
                       :disabled="personAuthForm.status==1">
              支付宝认证
            </el-button>
          </el-form>
        </div>
        <div class="ml50">
          <img src="../assets/images/xq1.png" alt="">
        </div>
      </div>
    </div>
    <div class="approve" v-if="active === 3 && authType==0">
      <div class="u-flex u-row-between">
        <div class="">
          <h3 class="title">个人认证</h3>
          <p class="desc">请打开支付宝扫描下方二维码</p>
          <img style="width: 300px;height: 300px;" :src="qr_code" alt="">
          <div class="mt10 u-flex">
            <el-button class="search" type="primary" @click="onSearch">查询结果</el-button>
            <el-button class="prev" type="primary" @click="onPrev">返回上一步</el-button>
          </div>
        </div>
        <div class="ml50">
          <img src="../assets/images/xq1.png" alt="">
        </div>
      </div>
    </div>
    <div class="approve" v-if="active === 3 && authType==1">
      <div class="u-flex u-row-between">
        <div class="">
          <h3 class="title">企业认证</h3>
          <p class="desc">请打开支付宝扫描下方二维码</p>
          <img style="width: 300px;height: 300px;" :src="qr_code" alt="">
          <div class="mt10 u-flex">
            <el-button class="search" type="primary" @click="onSearch">查询结果</el-button>
            <el-button class="prev" type="primary" @click="onPrev">返回上一步</el-button>
          </div>
        </div>
        <div class="ml50">
          <img src="../assets/images/xq1.png" alt="">
        </div>
      </div>
    </div>
    <div class="steps">
      <h3 class="title">操作引导</h3>
      <p>
        为响应国家相关规定，使用HTTP代理需完成实名认证。认证服务由支付宝提供，您的个人信息将受到严格保护，仅用于账户安全认证</p>
      <el-steps class="mt20" :active="active">
        <el-step title="注册卓泓HTTP账号"></el-step>
        <el-step title="完成实名认证"></el-step>
        <el-step title="领取福利套餐"></el-step>
        <el-step title="免费提取测试"></el-step>
      </el-steps>
    </div>
  </div>
</template>

<script>
import {baseUrl} from "@/utils/config";
import {getToken} from "@/utils/cache";
import upload from "@/components/upload.vue";

export default {
  components: {
    upload
  },
  name: 'Index',
  data() {
    return {
      baseUrl: baseUrl,
      authType: 0,
      personAuthForm: {
        cert_name: '',
        outer_order_no: '',
        passed: -1,
        base64: '',
      },
      enterpriseAuthForm: {
        outer_order_no: '',
        cert_name: '',
        enterprise_image: '',
        base64: '',
        passed: -1,
      },
      qr_code: '',
      outer_order_no: '',
      active: 1,
      fullurl: '',
      header: {
        token: getToken()
      },
      enterprTimer: null,
      userTimer: null,


    }

  },
  // 组件销毁前清空定时器
  beforeDestroy() {
    clearInterval(this.enterprTimer);
    this.enterprTimer = null;
    clearInterval(this.userTimer);
    this.userTimer = null;
  },
  created() {
    this.getAuthInit()
  },
  mounted() {
    this.curIdx = this.$route.params.index || 0
  },
  methods: {
    submitUserAuth() {
      this.$refs.personAuthForm.validate((valida) => {
        if (valida) {
          this.$api.RenalAuth.aliPersonFaceAuth(this.personAuthForm).then(res => {
            if (res) {
              this.qr_code = res.data.base64
              this.outer_order_no = res.data.outer_order_no
              this.active = 3
              // 轮询查询个人状态
              this.enterprTimer = setInterval(() => {

                this.$api.RenalAuth.getUserAuth({outer_order_no: this.outer_order_no}).then(res1 => {
                  if (res1.data && res1.data.passed != this.personAuthForm.passed && res1.data.passed != 0) {
                    clearInterval(this.userTimer);
                    this.userTimer = null;
                    this.$router.push({
                      path: '/rzNotice',
                      query: {
                        type: 1,
                        passed: res1.data.passed
                      }
                    })
                  }
                })

              }, 3000)
            }
          })
        }
      })
    },
    onAliApprove() {
      this.$refs.form.validate((valida) => {
        if (valida) {
          this.$api.RenalAuth.enterpriseAuth(this.enterpriseAuthForm).then(res => {
            if (res) {
              this.qr_code = res.data.base64
              this.outer_order_no = res.data.outer_order_no
              this.active = 3
              // 轮询查询企业认证状态
              this.userTimer = setInterval(() => {
                this.$api.RenalAuth.getEnterpriseAuth({outer_order_no: this.outer_order_no}).then(res1 => {
                  if (res1.data && res1.data.passed != this.enterpriseAuthForm.passed && res1.data.passed != 0) {
                      clearInterval(this.enterprTimer);
                      this.enterprTimer = null;
                      this.$router.push({
                        path: '/rzNotice',
                        query: {
                          type: 2,
                          passed: res1.data.passed
                        }
                      })
                  }

                })
              }, 5000)
            }
          })
        }
      })
    },
    getAuthInit() {
      this.$api.RenalAuth.getUserAuth().then(res => {
        if (res && res.data) {
          this.personAuthForm = res.data
        }
      })
      this.$api.RenalAuth.getEnterpriseAuth().then(res => {
        if (res && res.data) {
          this.enterpriseAuthForm = res.data
        }

      })
    },
    upload(data) {
      this.fullurl = data.fullurl
      this.enterpriseAuthForm.enterprise_image = data.fullurl
    },

    onTab(index) {
      this.navIndex = index
    },
    // 立即认证
    onOnceApprove(type) {
      this.active = 2
      this.authType = type
    },

    // 查询结果
    onSearch() {
      this.$api.RenalAuth.queryAuth({authType: this.authType, outer_order_no: this.outer_order_no}).then((res) => {
        this.$message.success('认证成功')

      })
    },
    // 返回上一步
    onPrev() {
      this.active = 1
      this.authType = 0
    },
  }
}
</script>

<style scoped>
.ps {
  margin-top: 20px;
  padding: 4px 10px;
  color: #fd6816;
  font-size: 14px;
  border-radius: 4px;
  background: #ffe6b5;
}

.title {
  text-align: left;
  font-size: 20px;
}

.approve {
  margin: 16px 0;
  //padding: 20px; //box-shadow: 2px 2px 20px 6px #f0f1f5;
}

.approve .item {

  padding-bottom: 40px;
  width: calc(50% - 10px);
  line-height: 36px;
  color: #000;
  font-size: 14px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 2px 2px 20px 6px #f0f1f5;
}

.approve .item img {
  width: 100%;
  display: block;
}

.name {
  font-size: 16px;
}

.solan {
  color: #666;
  font-size: 12px;
}

.once-approve {
  margin: 20px auto 0 !important;
  width: 80%;
  //background: #2682ff;
}

.success {
  color: #fd6816;
  font-size: 12px;
}

.desc {
  margin-top: 20px;
  line-height: 24px;
  color: #666;
  font-size: 12px;
}

.form {
  margin-top: 20px;
}

.form ::v-deep.el-form-item__label {
  color: #666;
  font-size: 14px;
}

form ::v-deep.el-input__inner {
  font-size: 14px;
  border: 1px solid #eee;
}

.pay {
  width: 300px;
  background: #2682ff;
}

.qrcode {
  width: 150px;
  height: 150px;
}

.search {
  width: 200px;
  background: #2682ff;
}

.prev {
  width: 200px;
  color: #2682ff;
  background: #d6e8ff;
  border-top: 1px soid #dbe7f3;
}

.steps {
  margin: 16px 0;
  padding: 20px;
  box-shadow: 2px 2px 20px 6px #f0f1f5;
}

.title {
  color: #000;
  font-size: 18px;
}

.steps p {
  line-height: 24px;
  color: #666;
  font-size: 12px;
}

</style>
